<template>
    <section class="content">
        <div class="container-fluid">
            <div class="block-header">
                <h2>{{ nama }}</h2>
            </div>
            <div class="row clearfix">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card">
                        <div class="header">
                            <h2>
                                {{ id_pdp_arahan != null ? 'Edit' : 'Tambah' }} {{ nama }}
                            </h2>
                        </div>
                        <div class="body">
                            <form class="form-horizontal" v-on:submit.prevent="save">
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="judul">Judul</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <form-line id="judul" type="text" v-model="content.judul"></form-line>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="konten">Konten</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <Ckeditor id="Konten" v-model="content.konten" :config="config"></Ckeditor>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="icon">File</label>
                                    </div>
                                    <div class="col-lg-2" v-if="content.file != null">
                                        <a class="btn btn-sm btn-info" target="_blank" v-bind:href="content.file"><i class="fa fa-paperclip"></i> File</a>
                                    </div>
                                    <div class="col-lg-8 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <input id="icon" class="form-control" type="file" name="icon" @change="handleFile($event)" />
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="tags">Tags</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <form-line type="text" id="tags" v-model="content.tags" :config="config"></form-line>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="tglBerlaku">Berlaku Sampai</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <flat-pickr class="form-control" id="tglBerlaku" v-model="content.tglBerlaku" :config="date"></flat-pickr>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                        <button v-if="id_pdp_arahan != null" @click="update" type="button" class="btn btn-warning waves-effect waves-button" v-waves.button><i class="material-icons">save</i> Edit</button>
                                        <button v-else @click="save" type="button" class="btn btn-primary waves-effect waves-button" v-waves.button><i class="material-icons">save</i> Simpan</button>
                                        <button @click="$router.go(-1)" type="button" class="btn btn-danger" v-waves.button><i class="material-icons">cancel</i> Batal</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
  import Ckeditor from 'vue-ckeditor2'
  import FormLine from '@/components/FormLine.vue'
  import api from '@/helper/api'

  export default {
    components: {
      FormLine,
      Ckeditor
    },
    name: 'ListNarasumber',
    data: function () {
      return {
        date: {
          dateFormat: 'Y-m-d',
          allowInput: true
        },
        config: {
          toolbar: [
            { name: 'stuff', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
            { name: 'morestuff', items: ['NumberedList', 'BulletedList'] },

            { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'] },
            { name: 'colors', items: ['TextColor'] },
            { name: 'paragraph2', items: ['JustifyLeft', 'JustiftyCenter', 'JustifyRight', 'Outdent', 'Indent'] },
            '/',
            { name: 'document', items: ['Source'] }
          ],
          height: 300
        },
        content: {
          judul: '',
          konten: '',
          tags: '',
          tglBerlaku: ''
        },
        file: '',
        id_pdp_arahan: '',
        nama: '',
        tipe: '',
        link: '',
        isLoading: false
      }
    },
    methods: {
      save () {
        this.isLoading = true
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        var form = new FormData()
        form.append('file', this.file)
        form.append('json', JSON.stringify(this.content))
        api.post('/pdp', form).then((result) => {
          if (result.data.code === 200) {
            this.$router.replace('/main/unduh/' + this.link)
            this.$toastr.s('Tambah data berhasil')
          } else {
            var msg = 'Tambah data gagal'
            if (result.data.message !== '') msg = result.data.message
            this.$toastr.e(msg)
          }
          this.isLoading = false
        }).catch(e => {
          var msg = 'Terjadi kesalahan pada server, mohon ulangi'
          if (e.response.data.message) msg = e.response.data.message
          this.$toastr.e(msg)
          this.isLoading = false
        })
      },
      update () {
        this.isLoading = true
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        var form = new FormData()
        form.append('file', this.file)
        form.append('json', JSON.stringify(this.content))
        api.post('/pdp/' + this.id_pdp_arahan, form).then((result) => {
          if (result.data.code === 200) {
            this.$router.replace('/main/unduh/' + this.link)
            this.$toastr.s('Ubah data berhasil')
          }
          this.isLoading = false
        }).catch((ex) => {
          var msg = 'Terjadi kesalahan pada server, mohon ulangi'
          if (ex.response.data.message) msg = ex.response.data.message
          this.$toastr.e(msg)
          this.isLoading = false
        })
      },
      getDetail () {
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.get('/pdp/' + this.id_pdp_arahan).then((result) => {
          this.content = result.data
        }).catch((ex) => {
          this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi')
        })
      },
      handleFile (file) {
        this.file = file.target.files[0]
      },
      checkRoute (route) {
        console.log(route.name)
        if (route.name === 'TambahPDP' || route.name === 'EditPDP') {
          this.link = 'pdp'
          this.nama = 'PDP'
          this.content.tipe = 1
        }

        if (route.name === 'TambahArahan' || route.name === 'EditArahan') {
          this.link = 'arahan'
          this.nama = 'Arahan'
          this.content.tipe = 2
        }
      }
    },
    mounted () {
      this.checkRoute(this.$route)
      this.id_pdp_arahan = this.$route.params.id
      if (this.id_pdp_arahan != null) {
        this.getDetail()
      }
    },
    '$route' (to, from) {
      this.checkRoute(to)
      this.getData()
    }
  }
</script>


// WEBPACK FOOTER //
// src/view/Unduh/PDP/FormPDP.vue?36e44cbf